<div class="body" [class.embedded-in-dialog]="inDialog" [formGroup]="formGroup">

    <mat-tab-group (selectedTabChange)="tabChanged($event)">

        <mat-tab label="Allgemein">

            <div class="tab">

                <mat-form-field class="width">
                    <mat-label>Benennung</mat-label>
                    <input formControlName="filtertext" placeholder="z.B. Aktive Verträge" matInput />
                </mat-form-field>

                <mat-form-field class="width">
                    <mat-label>Suchtyp wählen</mat-label>
                    <mat-select formControlName="filtertype">
                        <mat-select-trigger *ngIf="filtertypeControl.value">
                            {{filtertypeControl.value.title}}
                        </mat-select-trigger>
                        <mat-option *ngFor="let type of filterTypes" [value]="type">
                            {{type.title}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="width">
                    <mat-label>Beschreibung</mat-label>
                    <textarea rows=3 formControlName="filterdesc" matInput
                        placeholder="z.B. dieser Filter gibt ausschließlich aktive Verträge zurück"></textarea>
                </mat-form-field>

                <div class="sort-selection-container">
                    <mat-form-field class="width">
                        <mat-label>Sortierung ({{sortDirection}})</mat-label>
                        <mat-select formControlName="filtersortattribute">
                            <mat-select-trigger *ngIf="filtersortattributeControl.value">
                                {{filtersortattributeControl.value.title}}
                            </mat-select-trigger>
                            <mat-option *ngFor="let criteria of currentFilterType.criteria" [value]="criteria">
                                {{criteria.title}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="toggle">
                        <mat-slide-toggle formControlName="filtersortdsc"></mat-slide-toggle>
                    </div>
                </div>

                <div class="headline">
                    Darstellung
                </div>

                <div class="icon-preview-container">
                    <div class="icon-preview">
                        <mat-icon class="icon" [style.backgroundColor]="filterbackgroundcolorControl.value"
                            [style.color]="filtercolorControl.value">
                            {{filtericonControl.value}}
                        </mat-icon>
                    </div>
                    <div class="controls">

                        <app-select-icon-component [preSelected]="filtericonControl.value"
                            (selectionChanged)="setFilterIcon($event)"></app-select-icon-component>

                        <mat-form-field class="width">
                            <mat-label>Schriftfarbe</mat-label>
                            <input formControlName="filtercolor" [colorPicker]="filtercolorControl.value"
                                (colorPickerChange)="setFilterColor($event)" matInput readonly />
                        </mat-form-field>

                        <mat-form-field class="width">
                            <mat-label>Hintergrundfarbe</mat-label>
                            <input formControlName="filterbackgroundcolor"
                                [colorPicker]="filterbackgroundcolorControl.value"
                                (colorPickerChange)="setFilterBackgroundColor($event)" matInput readonly />
                        </mat-form-field>

                    </div>
                </div>

            </div>

            <div class="footer-control">
                <button mat-raised-button
                    [disabled]="!(formIsValid && (formHasChanges|| (compiledFilters.length > 0)))"
                    color="primary" (click)="saveFilter()">Speichern</button>
            </div>

        </mat-tab>

        <mat-tab label="Filterkriterien" [disabled]="!canModifyFilterConditions">

            <div class="tab">

                <div *ngIf="filtertypeControl.value && !savedFilter" class="criteria-suggestions">
                    <div class="sub-headline">
                        Verfügbare Suchfelder für {{filtertypeControl.value.title}}
                    </div>
                    <ng-container *ngFor="let criteria of filtertypeControl.value.criteria">
                        <div *ngIf="criteria.suggestionsProvider; else noSuggestions" class="label"
                            (click)="addCriteria(criteria)" [matMenuTriggerFor]="suggestionMenu">
                            {{criteria.title}}
                        </div>
                        <ng-template #noSuggestions>
                            <div class="label" (click)="addCriteria(criteria)">
                                {{criteria.title}}
                            </div>
                        </ng-template>
                    </ng-container>
                </div>

                <mat-form-field *ngIf="!savedFilter" class="width">
                    <mat-label>Ausdruck</mat-label>
                    <textarea rows=3 formControlName="filtercriteria" matInput></textarea>
                </mat-form-field>

                <div *ngIf="!savedFilter && corruptedConstantInStatement" class="warning-hint">
                    Wir haben eine invalide Eingabe erkannt, welche wahrscheinlich an einem falschen Vergleichsoperator
                    liegt. Bitte beachten Sie, dass die Filter momentan nur mit '=' (ist gleich) und '!=' (ist ungleich)
                    funktionieren.
                </div>

                <div *ngIf="statementValid && !savedFilter" style="text-align: center;">

                    <ng-container *ngFor="let term of compiledStatement">

                        <ng-container *ngIf="term.isOperator; else noOperator">

                            <div class="term operator" [matMenuTriggerFor]="menu">{{term.value}}</div>

                            <mat-menu #menu="matMenu">

                                <button mat-menu-item class="dropdown-item"
                                    (click)="setTermOperator('AND', term)">Und</button>

                                <button mat-menu-item class="dropdown-item"
                                    (click)="setTermOperator('OR', term)">Oder</button>

                            </mat-menu>

                        </ng-container>

                        <ng-template #noOperator>

                            <div class="term" [ngClass]="{
                                'symbol': term.isSymbol,
                                'constant': term.isConstant,
                                'beginParenthesis': term.isBeginParenthesis,
                                'endParenthesis': term.isEndParenthesis
                            }">{{term.value}}</div>

                        </ng-template>

                    </ng-container>

                </div>

                <div *ngIf="savedFilter">

                    <div class="saved-filter-headline">
                        Dieser Filter zeigt
                        <span class="type" *ngIf="this.filtertypeControl.value">
                            {{this.filtertypeControl.value.plural}}
                        </span>
                        , für welche gilt:
                    </div>
                    <app-filter-structure-preview [filter]="savedFilter" [filterType]="currentFilterType">
                    </app-filter-structure-preview>

                </div>

            </div>

            <div class="footer-control">
                <button mat-raised-button *ngIf="!savedFilter"
                    [disabled]="!(formIsValid && (formHasChanges|| (compiledFilters.length > 0)))"
                    color="primary" (click)="saveFilter()">Speichern</button>
                <button mat-raised-button *ngIf="savedFilter" color="warn" (click)="deleteSavedFilter()">
                    Kriterien löschen
                </button>
            </div>

        </mat-tab>

        <mat-tab *ngIf="rightsMap.isAdmin" label="Filter teilen" [disabled]="formHasChanges && !formIsValid">

            <div class="tab">

                <ng-container *ngFor="let entry of currentUserWidgetMap">

                    <div (click)="setUserUFSendingState(entry.user, $event)" class="entry-wrapper">

                        <mat-checkbox [checked]="sendFilterUsers[entry.user.id]" [disableRipple]="true"
                            (click)="$event.preventDefault()"></mat-checkbox>
                        

                    </div>

                    <ng-container *ngIf="entry.widgets.length === 1 && sendFilterUsers[entry.user.id]">

                        <span class="only-one-widget-hint">
                            Dieser Nutzer hat nur ein {{widgetTypeName}} auf dem Dashboard, sodass der Filter diesem
                            zugewiesen wird.
                        </span>

                    </ng-container>

                    <ng-container *ngIf="entry.widgets.length > 1">

                        <div (click)="setWidgetUFSendingState(widget, $event)" *ngFor="let widget of entry.widgets"
                            class="widget-entry-wrapper">
                            <mat-checkbox [checked]="sendFilterWidgets[widget.widgetid.toString()]"
                                [disableRipple]="true" (click)="$event.preventDefault()"></mat-checkbox>
                            <span>
                                {{widgetTypeName}}, ID: {{widget.widgetid}}, Position (x, y, w, h): ({{widget.widgetx}},
                                {{widget.widgety}}, {{widget.widgetw}}, {{widget.widgeth}})
                            </span>
                        </div>

                    </ng-container>


                </ng-container>

            </div>

            <div class="footer-control">
                <button mat-raised-button *ngIf="!isSendingUserFilters && !userFiltersSended"
                    [disabled]="sendFilterTasks == 0" color="primary" (click)="sendFilters()">
                    {{sendFilterTasks}} Filter erzeugen
                </button>
                <mat-spinner *ngIf="isSendingUserFilters" [diameter]="20"></mat-spinner>
                <span *ngIf="userFiltersSended" class="user-filters-created">
                    {{sendFilterTasks}} Filter wurde(n) erzeugt
                </span>
            </div>

        </mat-tab>

    </mat-tab-group>

</div>

<mat-menu #suggestionMenu="matMenu">
    <button *ngFor="let suggestion of currentSuggestions" mat-menu-item class="dropdown-item"
        (click)=addCriteriaValue(suggestion)>
        <span>{{ suggestion.title }}</span>
    </button>
</mat-menu>
